import RouteUpdateConstants from "./RouteUpdateConstants.js";
class RouteUpdateActions {
  routeUpdate(location) {
    return {
      type: RouteUpdateConstants.ROUTE_UPDATE,
      payload: location
    };
  }
}
const RouteUpdateActions$1 = new RouteUpdateActions();
export {
  RouteUpdateActions,
  RouteUpdateActions$1 as default
};
//# sourceMappingURL=RouteUpdateActions.js.map
